import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useToast,
    FormControl,
    FormLabel,
    Textarea,
    Flex,
} from "@chakra-ui/react";
import { useState } from "react";
import { FaRegFileExcel } from "react-icons/fa";
import { IoCloseOutline } from "react-icons/io5";
import { useManajemenPengetahuanPendaftarDetailContext } from "../../../controller/admin/manajemen_pengetahuan/pendaftar/detail";

interface ModalRejectPendaftarProps {
    pengetahuan_id: string;
    id: string;
}

const ModalRejectPendaftar = ({ pengetahuan_id, id }: ModalRejectPendaftarProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [steps, setSteps] = useState(1);


    const toast = useToast();
    const { handleReject, setPengetahuanPendaftarDetail } =
        useManajemenPengetahuanPendaftarDetailContext().dispatch;
    const { isLoadingAction, reason } =
        useManajemenPengetahuanPendaftarDetailContext().state;

    const handleClose = () => {
        setIsOpen(false);
        setSteps(1);
        setPengetahuanPendaftarDetail("reason", "");
    };

    return (
        <>
            <Button colorScheme="red" onClick={() => setIsOpen(true)}>
                Tolak
            </Button>

            {/* Step 1 */}
            <Modal isOpen={isOpen} onClose={handleClose} size={steps === 1 ? "2xl" : "md"}>
                <ModalOverlay />
                <ModalContent>
                    {steps === 1 ? (
                        <>
                            <ModalHeader>
                                <Text fontWeight="semibold" fontSize="md">
                                    Tolak Pengajuan Verifikasi Peserta
                                </Text>
                                <Button
                                    onClick={handleClose}
                                    position="absolute"
                                    top={2}
                                    right={2}
                                    colorScheme="red"
                                    size="sm"
                                    borderRadius="md"
                                    p={0}
                                    minW="28px"
                                    h="28px"
                                >
                                    <IoCloseOutline size={18} />
                                </Button>
                            </ModalHeader>

                            <ModalBody>
                                <FormControl isRequired>
                                    <FormLabel fontSize="sm" fontWeight="medium" mb={2}>
                                        Alasan Menolak Pengajuan
                                    </FormLabel>
                                    <Textarea
                                        placeholder="Masukan Alasan *"
                                        value={reason}
                                        onChange={(e) =>
                                            setPengetahuanPendaftarDetail("reason", e.target.value)
                                        }
                                    />
                                </FormControl>
                            </ModalBody>

                            <ModalFooter justifyContent="end" gap={3}>
                                <Button bg="gray.500" mr={2} color="white" onClick={handleClose}>
                                    Batal
                                </Button>
                                <Button
                                    colorScheme="red"
                                    onClick={() => {
                                        if (!reason.trim()) {
                                            toast({
                                                title: "Alasan wajib diisi",
                                                status: "warning",
                                                duration: 3000,
                                                isClosable: true,
                                                position: "top-right",
                                            });
                                            return;
                                        }
                                        setSteps(2);
                                    }}
                                >
                                    Tolak
                                </Button>
                            </ModalFooter>
                        </>
                    ) : (
                        <>
                            <ModalHeader>
                                <Button
                                    onClick={handleClose}
                                    position="absolute"
                                    top={2}
                                    right={2}
                                    colorScheme="red"
                                    size="sm"
                                    borderRadius="md"
                                    p={0}
                                    minW="28px"
                                    h="28px"
                                >
                                    <IoCloseOutline size={18} />
                                </Button>
                            </ModalHeader>

                            <ModalBody textAlign="center">
                                <Flex justify="center" my={4}>
                                    <Flex
                                        bg="red.500"
                                        borderRadius="full"
                                        w="50px"
                                        h="50px"
                                        align="center"
                                        justify="center"
                                    >
                                        <FaRegFileExcel color="white" size={24} />
                                    </Flex>
                                </Flex>
                                <Text fontWeight="semibold" fontSize="md" mb={2}>
                                    Apakah Anda yakin ingin menolak pengajuan ini?
                                </Text>
                            </ModalBody>

                            <ModalFooter justifyContent="center" gap={3}>
                                <Button bg="gray.500" mr={2 } color="white" onClick={() => setSteps(1)}>
                                    Batal
                                </Button>
                                <Button
                                    colorScheme="green"
                                    isLoading={isLoadingAction}
                                    disabled={isLoadingAction}
                                    onClick={() => handleReject(Number(pengetahuan_id), Number(id), handleClose)}
                                >
                                    Ya
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    );
};

export default ModalRejectPendaftar;
